import { Button, Flex } from "@utilitywarehouse/hearth-react";

import { QuestionsDataTest } from "./constants";

interface NavigationButtonsProps {
  onBack: () => void;
  onContinue: () => void;
  forwardName?: string;
  disableNext?: boolean;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onBack,
  onContinue,
  forwardName = "Continue",
  disableNext = false,
}) => {
  return (
    <Flex gap="150">
      <Button
        onClick={onBack}
        colorScheme="functional"
        variant="outline"
        data-testid={QuestionsDataTest.BACK_BTN}
      >
        Back
      </Button>

      <Button
        onClick={onContinue}
        disabled={disableNext}
        data-testid={QuestionsDataTest.CONTINUE_BTN}
      >
        {forwardName}
      </Button>
    </Flex>
  );
};

export default NavigationButtons;
